import axios from 'axios'
import store from '../store';
import { pickBy, isNil } from 'lodash';
import authHelper from './auth.js';

export const API_URL = process.env.API_URL;

export const isRequestError = (error) => {
	return error.response || error.request;
}

const authInstance = axios.create({
	baseURL: API_URL
});

const apiCall = () => {
	return authInstance;
};

const apiFile = (uri, params) => {
	let query = '&';
	if (!isNil(params)) {
		query += queryString(params);
	}

	return authHelper.getValidAccessToken().then(response => {
		return `${API_URL}${uri}?token=${response}${query}`;
	});

}

const queryString = (obj) => {
	return Object.keys(obj).reduce(function(a, k) { a.push(k + '=' + encodeURIComponent(obj[k])); return a }, []).join('&');
}

const apiLogin = axios.create({ baseURL: API_URL });

const filterParams = (params) => pickBy(params, (value) => !isNil(value));

export {
	apiCall,
	apiLogin,
	apiFile,
	filterParams,
	authInstance
}


// WEBPACK FOOTER //
// ./src/helpers/axios.js